import { z } from 'zod';

import { schemaEuropaceBeschaeftigung } from './Beschaeftigung';
import { schemaEuropaceHerkunft } from './Herkunft.schema';
import { schemaEuropacePersonendaten } from './Personendaten.schema';
import { schemaEuropaceWohnsituation } from './Wohnsituation.schema';

/*
    https://docs.api.europace.de/privatkredit/vorgaenge/kex-vorgang-import-api/#antragsteller

    {
        "herkunft": Herkunft,
        "personendaten": Personendaten,
        "wohnsituation": Wohnsituation,
        "beschaeftigung": Beschäftigung
    }

*/
export const schemaEuropaceAntragsteller = z.object({
    beschaeftigung: z.optional(schemaEuropaceBeschaeftigung),
    herkunft: z.optional(schemaEuropaceHerkunft),
    personendaten: z.optional(schemaEuropacePersonendaten),
    wohnsituation: z.optional(schemaEuropaceWohnsituation),
});

export type SchemaEuropaceAntragsteller = z.infer<typeof schemaEuropaceAntragsteller>;
